import { ISortOrder } from './../sort-toggle/sort-toggle.component';
import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { OrganizationClassData } from '../data/organization-detail';

@Component({
  selector: 'app-organization-classes-data',
  templateUrl: './organization-classes-data.component.html',
  styleUrls: ['./organization-classes-data.component.scss']
})
export class OrganizationClassesDataComponent extends BaseComponent implements OnInit {
  @Input() organizationId: number;
  classes: OrganizationClassData[];
  classesDataLoaded: boolean = false;
  hasClasses: boolean = false;

  ngOnInit() {
    this.dataService.getOrganizationClassesData(this.organizationId).subscribe(classData => this.getOrgClassesData(classData));
  }

  getOrgClassesData(classData: OrganizationClassData[]): void {
    if (classData !== undefined && classData.length > 0)
    {
      this.classes = classData;
      this.hasClasses = true;
    }
    this.classesDataLoaded = true;
  }

  getActiveStudentsString(totalStudentCount: number, activeStudentCount: number): string {
    if (totalStudentCount === 0 || this.getUndefinedCheck(activeStudentCount) || this.getUndefinedCheck(totalStudentCount)) return "N/A";

    var percentage = (activeStudentCount / totalStudentCount) * 100;
    if (Math.floor(percentage) === percentage) {
      return percentage.toString() + "%";
    }
    return percentage.toFixed(1) + "%";
  }

  getFormattedTimeString(totalMinutes: number): string {
    if (this.getUndefinedCheck(totalMinutes)) return "0 min";
    var hour = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    return (hour === 0) ? minutes + " min" : hour + " hr" + ((minutes === 0) ? "" : (" " + minutes + " min"));
  }

  getUnitTestAverage(AverageUnitTestPctCorrect: number): string {
    if (this.getUndefinedCheck(AverageUnitTestPctCorrect)) return "N/A";
    return AverageUnitTestPctCorrect + "%";
  }

  getUndefinedCheck(value: number): boolean {
    return typeof value === 'undefined' || value === null;
  }

  getUndefinedCheckString(value: string): boolean {
    return value === "" || value === null || typeof value === 'undefined'
  }

  updateSort(sortOrder: ISortOrder) {
    this.classes.sort((a, b) => {
      var sortVal =
        sortOrder.orderBy === 'TeacherName' ? this.sortString(a.TeacherName, b.TeacherName) :
          sortOrder.orderBy === 'StudentCount' ? this.sortNumbers(a.StudentCount, b.StudentCount) :
            sortOrder.orderBy === 'ActiveStudentCount' ? this.activePercentSort(a, b) :
              sortOrder.orderBy === 'AverageMinutesInProduct' ? this.sortNumbers(a.AverageMinutesInProduct, b.AverageMinutesInProduct) :
                sortOrder.orderBy === 'AverageUnitTestPctCorrect' ? this.sortNumbers(a.AverageUnitTestPctCorrect, b.AverageUnitTestPctCorrect) :
                  sortOrder.orderBy === 'TotalNumSpeakingOpportunities' ? this.sortNumbers(a.TotalNumSpeakingOpportunities, b.TotalNumSpeakingOpportunities) :
                    sortOrder.orderBy === 'AverageSparcScore' ? this.sortNumbers(a.AverageSparcScore, b.AverageSparcScore) :
                      this.sortString(a.Description, b.Description);
      if (!sortOrder.ascending) sortVal *= -1;
      return sortVal;
    });
  }

  sortString(stringA, stringB) {
    var stringNameA = this.getUndefinedCheck(stringA) ? "" : stringA;
    var stringNameB = this.getUndefinedCheck(stringB) ? "" : stringB;
    return stringNameA.localeCompare(stringNameB);
  }

  activePercentSort(a, b) {
    var percentageA = 0;
    var percentageB = 0;
    if (a.StudentCount === 0 || this.getUndefinedCheck(a.ActiveStudentCount) || this.getUndefinedCheck(a.StudentCount)) {
      percentageA = -1;
    } else {
      percentageA = (a.ActiveStudentCount / a.StudentCount) * 100;
    }
    if (b.StudentCount === 0 || this.getUndefinedCheck(b.ActiveStudentCount) || this.getUndefinedCheck(b.StudentCount)) {
      percentageB = -1;
    } else {
      percentageB = (b.ActiveStudentCount / b.StudentCount) * 100;
    }
    return this.sortNumbers(percentageA, percentageB);
  }

  sortNumbers(numA, numB) {
    var cleanNumA = this.getUndefinedCheck(numA) ? -1 : numA;
    var cleanNumB = this.getUndefinedCheck(numB) ? -1 : numB;
    return cleanNumA - cleanNumB;
  }
}
